import config from "../../config";

/** Absolute URL for a media path returned by the API.
 *
 * Django serves MEDIA_URL as a root-relative path ("/mediafiles/..."), which the browser
 * would resolve against the frontend's own origin rather than the API's. S3-backed uploads
 * already come back absolute, so those pass through untouched.
 *
 * Its own module rather than designTokens because it depends on config — this is API
 * plumbing, not a design value. Previously duplicated byte-for-byte in QE oversight and
 * the H&S vehicle step.
 */
export function resolveMediaUrl(path) {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  try {
    return new URL(config.REACT_APP_SECRET_API).origin + path;
  } catch {
    // A malformed API base is not worth failing a render over — the relative path at
    // least still works when the two are served from the same origin.
    return path;
  }
}
